import {
  lW as loadWasm,
  makeGsW as getSignatureWasm,
} from '@debank/isomorphic/es/sign-wasm-mainsite';
import * as Sentry from '@sentry/browser';

import { makeGs as getSignatureJS } from '@debank/isomorphic/es/sign-js-mainsite';

import { IS_SUPPORT_WASM, SWITCH_FORCE_WASM_SIGN, SWITCH_SIGN_V2_1 } from './security';

const SIGN_VER = SWITCH_SIGN_V2_1 ? 'v2.1' : 'v2';

const SignErrorType = {
  WASM: '0',
  JS: '1',
} as const;

const DEFAULT_RESULT = { signature: '', nonce: '', ts: '', version: SIGN_VER };

const signRecords = {
  succeedOnWasm: false,
  /** @description record wasm load failure */
  recordedWasm: false,
  // recordedJS: false,
};

export async function getSignature(
  ...[params, method, uripath]: Parameters<typeof getSignatureJS>
) {
  if (IS_SUPPORT_WASM && SWITCH_FORCE_WASM_SIGN && !signRecords.recordedWasm) {
    try {
      if (SIGN_VER === 'v2.1') {
        await loadWasm(100121);
      } else {
        await loadWasm(100120);
      }

      const result = getSignatureWasm(params, method, uripath, { version: SIGN_VER });
      signRecords.succeedOnWasm = true;

      return result;
    } catch (err) {
      signRecords.recordedWasm = true;
      Sentry.captureEvent({
        message: 'getSignature Failed',
        tags: {
          error: 'SignFailed',
          type: `${SignErrorType.WASM}`,
          hasSuccess: `${signRecords.succeedOnWasm}`,
        },
        extra: { err, version: SIGN_VER },
      });
    }
  }

  try {
    return getSignatureJS(params, method, uripath, { version: SIGN_VER });
  } catch (err) {
    // signRecords.recordedJS = true;
    Sentry.captureEvent({
      message: 'getSignature Failed',
      tags: {
        error: 'SignFailed',
        type: `${SignErrorType.JS}`,
        failedOnW: `${signRecords.recordedWasm}`,
      },
      extra: { err, version: SIGN_VER },
    });

    return { ...DEFAULT_RESULT };
  }
}
